import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IConnectionWithTotal, IEmployee } from '@api/types'
import { PageInfoFragment, EmployeeFragment } from '@api/fragments'

interface Payload {
  data: {
    node: {
      employeeConnection: IConnectionWithTotal<IEmployee>
    }
  }
}

export const departmentEmployeesQuery = gql`
  query DepartmentEmployees(
    $id: ID!
    $first: Int
    $after: String
    $orderBy: EmployeeOrderByEnum
    $where: EmployeeWhereInput
  ) {
    node(id: $id) {
      ... on Department {
        employeeConnection(first: $first, after: $after, orderBy: $orderBy, where: $where) {
          counters {
            total
          }
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...EmployeeFragment
            }
          }
        }
      }
    }
  }
  ${PageInfoFragment}
  ${EmployeeFragment}
`

export default function list(variables: {
  departmentId: string
  first?: number
  after?: string
  query?: string
}): Promise<IConnectionWithTotal<IEmployee>> {
  const { departmentId, first = 5, query = '', after = '' } = variables

  return client.gql
    .query({
      query: departmentEmployeesQuery,
      variables: {
        id: departmentId,
        first,
        after,
        orderBy: 'name_ASC',
        where: { OR: [{ name_contains: query }, { email_contains: query }] },
      },
    })
    .then(({ data: { node } }: Payload) => node.employeeConnection)
}
